export default __webpack_public_path__ + "static/media/pnvsca.9f8384cb.JPG";